/** Typed element lookups that fail loudly instead of yielding null downstream. */

export function el<T extends HTMLElement = HTMLElement>(id: string): T {
  const node = document.getElementById(id);
  if (!node) throw new Error(`Elementul #${id} lipsește din pagină`);
  return node as T;
}

export const select = (id: string): HTMLSelectElement => el<HTMLSelectElement>(id);
export const input = (id: string): HTMLInputElement => el<HTMLInputElement>(id);
export const button = (id: string): HTMLButtonElement => el<HTMLButtonElement>(id);

export function option(value: string, label: string): HTMLOptionElement {
  const opt = document.createElement('option');
  opt.value = value;
  opt.textContent = label;
  return opt;
}

export function fillSelect(sel: HTMLSelectElement, items: ReadonlyArray<[string, string]>): void {
  sel.replaceChildren(...items.map(([value, label]) => option(value, label)));
}

export type StatusKind = '' | 'ok' | 'warn' | 'err';

export function setStatus(node: HTMLElement, text: string, kind: StatusKind = ''): void {
  node.textContent = text;
  node.className = kind ? `status ${kind}` : 'status';
}

export function show(node: HTMLElement, visible: boolean): void {
  node.hidden = !visible;
}

/** Coalesce repeated calls into one per animation frame. */
export function rafThrottle(fn: () => void): () => void {
  let scheduled = false;
  return () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      fn();
    });
  };
}
